import { render } from "./ProductSellers.vue?vue&type=template&id=74876cc6&scoped=true"
import script from "./ProductSellers.vue?vue&type=script&lang=js"
export * from "./ProductSellers.vue?vue&type=script&lang=js"

import "./ProductSellers.vue?vue&type=style&index=0&id=74876cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74876cc6"]])

export default __exports__